import {
  createQuote,
  generateQuoteCode,
  getListOldQuotes,
  getQuoteHistory,
} from '@/services/quote';
import { CATEGORY_KEYS, FORMAT_DATE, GENERATION_V3, QUESTION_KEY_HAS_OTHER_INPUT } from '@/utils/constants';
import { autofillPerson2QuestionKeys } from '@/utils/flows/version_3';
import { getFormatDate, getDynamicAnswerKey, getDynamicAnswerValue, isRenew, NOT_INPUT_OTHER, QUESTIONS_KEY, RECIPIENTS, transfersInfo, transfersUnit, DEFAULT_CATEGORY_RECIPIENTS, CATEGORY_FOR_CONVERT_HISTORY_ANSWERS } from '@/utils/utils';
import { removeFreshAnswers } from '@/utils/reassessment';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useModel, useRequest } from 'umi';

export default function useQuoteModel(): any {
  const { client = {} as API.Client, isDemo, isCommonApp, market, generation } = useModel('client');
  const {
    answers,
    getQuestionByKey,
    setAnswers,
    sortAnswers,
    fetchCategories,
    getAnswerAdditionalPerson,
    IadlServices,
    categories,
    setCategories,
    questions,
    careRecipientName,
    priorAnswers,
    setObjectState,
  } = useModel('question');

  const [quote, setQuote] = useState<API.Quote>();
  const [quoteCode, setQuoteCode] = useState('');
  const [addedForCall, setAddedForCall] = useState(false);
  const [savedDraft, setSavedDraft] = useState(false);
  const [isPrimaryQuote, setIsPrimaryQuote] = useState(true);
  const [isSibling, setIsSibling] = useState(false);
  const [createdQuote, setCreatedQuote] = useState(false);
  const [generatedNewQuote, setGeneratedNewQuote] = useState(false);
  const isHiddenPrice = useRef(false);
  const sendMail = useRef(false);
  const quoteDataRef = useRef({})
  const convertAnswerKey = (answerKey: string) => {
    return {
      qRecipient: answerKey.split('/')[0],
      qCategoryKey: answerKey.split('/')[1],
      qKey: answerKey.split('/')[2],
      optionKey: answerKey.split('/')[3],
    };
  };

  const { loading, run: runCreateQuote } = useRequest(
    (params: any) => createQuote({ ...params, isDemo }),
    {
      cacheKey: 'createQuote',
      manual: true,
      formatResult: (res) => res,
    },
  );

  const { loading: loadingGenerateQuoteCode, run: runGenerateQuoteCode } = useRequest(
    (appType: string) => generateQuoteCode(appType),
    {
      cacheKey: 'generateQuoteCode',
      manual: true,
      formatResult: (res) => res as API.QuoteCode,
      onSuccess: (data) => {
        setQuote(data);
        setQuoteCode(data?.quoteCode);
      },
    },
  );

  const convertAnswers = (convertKey = false) => {
    if (!Object.entries(answers)?.length) return {};
    const result: any = Object.entries(sortAnswers(answers))
        .filter(([key, value]) => key && !!value)
      .reduce((prev: any, cur: any) => {
          const { qKey, qRecipient, optionKey } = convertAnswerKey(cur[0]);
          if (!qKey) return prev;
          const question = getQuestionByKey(qKey);
          prev[`${RECIPIENTS[qRecipient]}`] = prev[`${RECIPIENTS[qRecipient]}`] || {};
          let value = null;
          if (convertKey) {
            if (optionKey) {
              prev[`${RECIPIENTS[qRecipient]}`][`${qKey}/${optionKey}`] = cur[0];
            } else {
              prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] = cur[0];
            }

            if (qKey === QUESTIONS_KEY.RECIPIENT_DOB_AGE) {
              prev[`${RECIPIENTS[qRecipient]}`][`${QUESTIONS_KEY.RECIPIENT_DOB}`] = cur[0].substring(0, cur[0].search("Age"))
            }
            return prev;
          } else {
            if (question?.type === 'date') {
              value = moment(cur[1]).toISOString(true);
            } else if (question?.type === 'datetime') {
              if (answers[cur[0] + 'date']) {
                value = `${moment(answers[cur[0] + 'date'], getFormatDate(market)).format(getFormatDate(market))} ${answers[cur[0] + 'time'] || ""
                  }`;
              }
            } else if (qKey.includes('Other') || qKey.includes('Uncertain')) {
              value = prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] || {};
              if (optionKey) {
                if ((qKey === QUESTIONS_KEY.PET_CARE_OTHER || qKey === QUESTIONS_KEY.TRANSFERS_OTHER)) {
                  const prevValue = prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`];

                  if (prevValue) {
                    value = [prevValue, optionKey + ":" + cur[1]].join(", ");
                    if (qKey === QUESTIONS_KEY.TRANSFERS_OTHER) {
                      value = [prevValue, optionKey + ":" + " " + cur[1] + " " + transfersUnit[optionKey]].join(", ");

                      if (optionKey === "select") {
                        value = [prevValue, cur[1]].join(", ");
                      }
                    }
                  } else {

                    value = optionKey + ":" + cur[1];
                    if (qKey === QUESTIONS_KEY.TRANSFERS_OTHER) {
                      value = optionKey + ":" + " " + cur[1] + " " + transfersUnit[optionKey];
                      if (optionKey === "select") {
                        value = cur[1];
                      }
                    }
                  }


                } else if (optionKey.includes('Other')) {
                  if (typeof value === "object") {
                    if (qKey.includes(QUESTIONS_KEY.TREATMENTS)) {
                      value[optionKey?.split('Other')?.[0]] = `${value[optionKey?.split('Other')?.[0]]}${(optionKey.indexOf("Other") + "Other".length) === optionKey.length ? ":" : " - "} ${cur[1] == "OT" ? "Other" : cur[1] == "@UN" ? "Uncertain" : `${cur[1]}`}`;
                    } else {
                      value[optionKey?.split('Other')?.[0]] = `${value[optionKey?.split('Other')?.[0]]} : ${cur[1] == "OT" ? "Other" : cur[1] == "@UN" ? "Uncertain" : cur[1]}`;
                    }
                  }

                } else {
                  value[`${optionKey}`] = cur[1];
                }
              } else {
                if (typeof value == 'string') {
                  value = {};
                }
                value[qKey.includes('Other') ? 'OT' : '@UN'] = cur[1]?.toString();

              }
            } else {
              value =
                ['select_chip_single', 'radio', 'select_dropdown'].includes(question?.type)
                  ? [cur[1]]
                  : cur[1];
            }

          }
          if ([QUESTIONS_KEY.BATHING, QUESTIONS_KEY.NUTRITION].includes(question.key)) {
            let otherAnswers = answers[`${cur[0]}OtherKey`];
            if (otherAnswers) {
              if (otherAnswers.includes("OT")) {
                otherAnswers = otherAnswers.map((answer: string) => answer === "OT" ? `Other: ${answers[`${cur[0]}OtherKeyOther`]}` : answer)
              }
              prev[`${RECIPIENTS[qRecipient]}`][`${question.key}Other`] = otherAnswers.join(", ")
            }
          }
          if (qKey === QUESTIONS_KEY.RECIPIENT_DOB_AGE) {
            const valueDOB = [prev[`${RECIPIENTS[qRecipient]}`][`${QUESTIONS_KEY.RECIPIENT_DOB}`], cur[1]];
            prev[`${RECIPIENTS[qRecipient]}`][`${QUESTIONS_KEY.RECIPIENT_DOB}`] = valueDOB
          }
          if (isCommonApp) {
            if (question.key === QUESTIONS_KEY.CONTACT_TIME_DATE) {
              value = `Name: ${answers[cur[0] + 'name']}, Phone: ${answers[cur[0] + 'phone']}, Email: ${answers[cur[0] + 'email']}, Contact time: ${moment(moment(answers[cur[0] + 'date'], getFormatDate(market))).format(getFormatDate(market))} ${answers[cur[0] + 'time']} ${answers[cur[0] + 'timeZone']}`;
            }

            if (question.key === QUESTIONS_KEY.RELATIONSHIP) {

              let otherAnswers = answers[`${cur[0]}OtherKey`];
              if (otherAnswers) {
                if (otherAnswers == "OT") otherAnswers = "Other: " + answers[`${cur[0]}OtherKeyOther`]
                prev[`${RECIPIENTS[qRecipient]}`][`${QUESTIONS_KEY.RELATIONSHIP}Other`] = otherAnswers;
              }
            }

          }
          if (generation === GENERATION_V3 && qKey.includes('followUpQ')) {
            prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] = prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] || {};
            const prevValue = prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] || {};
            const questionByKey = getQuestionByKey(qKey.replace('followUpQ', ''));

            // covert answer for case type = select_chip_multi
            if (questionByKey?.type === 'select_chip_multi') {
              const optionFollowUpKey = cur[0]?.split('/')?.[4];
              if (!!optionFollowUpKey) {
                const prevOptionValue = prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`][optionKey] || {};
                prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`][optionKey] = { ...prevOptionValue, ...{ [optionFollowUpKey]: value } };
                return prev;
              }
            }
            prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] = { ...prevValue, ...{ [optionKey]: value } };
            return prev;
          }
          //Automatically set the relationship when the care recipient fills out the form.
          if (generation === GENERATION_V3 && qRecipient === DEFAULT_CATEGORY_RECIPIENTS && qKey === QUESTIONS_KEY.IS_STAFF) {
            if (Array.isArray(value) && value.includes("2")) {
             prev[`${RECIPIENTS[qRecipient]}`][QUESTIONS_KEY.RELATIONSHIP] = ["self"];
            }
          }
          prev[`${RECIPIENTS[qRecipient]}`][`${qKey}`] = value;
          return prev;
      }, {});

    // Shared Household Facts (TRM 7.1): only autofill when 2nd person is full care
    const p1Key = RECIPIENTS[DEFAULT_CATEGORY_RECIPIENTS];
    const p2FullCareKey = RECIPIENTS['full_care_2nd_recipient'];
    if (result[p2FullCareKey] && result[p1Key]) {
      autofillPerson2QuestionKeys.forEach((key) => {
        if (result[p1Key][key] !== undefined && result[p2FullCareKey][key] === undefined) {
          result[p2FullCareKey][key] = result[p1Key][key];
          // copy the follow-up answers and explanation inputs together with the main answer
          ['followUpQ', 'Other', 'Uncertain'].forEach((suffix) => {
            if (result[p1Key][`${key}${suffix}`] !== undefined) {
              result[p2FullCareKey][`${key}${suffix}`] = result[p1Key][`${key}${suffix}`];
            }
          });
        }
      });
    }

    return result;
  };
  const setCareRecipientName = (currentQuestion: any) => {
    const recipientName1st = getDynamicAnswerKey(Object.keys(currentQuestion), QUESTIONS_KEY.RECIPIENT_NAME)
    const recipientNamefull = getDynamicAnswerKey(Object.keys(currentQuestion), QUESTIONS_KEY.RECIPIENT_NAME, CATEGORY_FOR_CONVERT_HISTORY_ANSWERS["3"]);
    const recipientNameMinimal = getDynamicAnswerKey(Object.keys(currentQuestion), QUESTIONS_KEY.RECIPIENT_NAME, CATEGORY_FOR_CONVERT_HISTORY_ANSWERS["2"]);
    if (recipientName1st) {
      careRecipientName.current[DEFAULT_CATEGORY_RECIPIENTS] = currentQuestion[recipientName1st];
    }
    if (recipientNamefull) {
      careRecipientName.current[QUESTIONS_KEY.RECIPIENT_NAME, CATEGORY_FOR_CONVERT_HISTORY_ANSWERS["3"]] = currentQuestion[recipientNamefull];
    }
    if (recipientNameMinimal) {
      careRecipientName.current[QUESTIONS_KEY.RECIPIENT_NAME, CATEGORY_FOR_CONVERT_HISTORY_ANSWERS["2"]] = currentQuestion[recipientNameMinimal];
    }
  }

  const submitCreateQuote = async () => {
    const res = await runCreateQuote({
      answers: convertAnswers(),
      client: client?.appType,
      quoteCode: quoteCode,
      answersKey: convertAnswers(true),
      isRenew: !generatedNewQuote && isRenew,
      sendMail: sendMail.current,
      isSendContactMail: !!getDynamicAnswerValue(answers, QUESTIONS_KEY.CONTACT_TIME_DATE_EMAIL) && answers["isSendContactMail"],
      isHiddenPrice: isHiddenPrice.current,
    });
    setGeneratedNewQuote(true);
    setCreatedQuote(true);
    setIsPrimaryQuote(!!res?.isPrimaryQuote);
    setIsSibling(!!res?.isSibling);
    setQuoteCode(res.quoteCode);
    setQuote(res);

    return res;
  };

  const saveDraft = async (value: any) => {
    await runCreateQuote({
      answers: convertAnswers(),
      client: client?.appType,
      quoteCode: quoteCode,
      isDraft: 1,
      answersKey: convertAnswers(true),
      saveDraftInfo: value
    });
    setSavedDraft(true);
  };
  const saveDraftCommonApp = async (value: any) => {
    await runCreateQuote({
      answers: convertAnswers(),
      client: client?.appType,
      quoteCode: quoteCode,
      isDraft: 1,
      answersKey: convertAnswers(true),
      saveDraftInfo: value
    });
    setSavedDraft(true);
  };
  const convertQuoteHistory = (answersHistory: any) => {
    const result = answersHistory.reduce((prev: any, cur: any) => {
      const { question = {}, answer = [] } = cur;
      const answerKey = cur?.answerExtra?.key;
      const address = cur?.answerExtra?.address;
      if (!answerKey) return prev;

      answer?.forEach((a: any) => {

        if (a.key === 'OT') prev[`${answerKey}Other`] = a.value;
        if (a.key === '@UN') prev[`${answerKey}Uncertain`] = a.value;

        if (['select_chip_single', 'radio', 'select_dropdown'].includes(question?.type)) {
          prev[`${answerKey}`] = a.key || a.value;
          if (a.key && a.value && !NOT_INPUT_OTHER.includes(question.key)) {
            prev[`${answerKey}Other`] = a.value
          }

          if (!!a.followUpValue) {
            const followUpKeys = Object.keys(a.followUpValue);
            followUpKeys.forEach((followUpKey: string) => {
              prev[`${answerKey}followUpQ/${followUpKey}`] = a.followUpValue[followUpKey]
            })
          }

        } else if (question?.type === 'select_chip_multi') {
          prev[`${answerKey}`] = prev[`${answerKey}`] || [];
          prev[`${answerKey}`] = [...prev[`${answerKey}`], a.key];
          if (a.key && !!a.value) {
            prev[`${answerKey}Other/${a.key}`] = a.value;
            if (question.key === QUESTIONS_KEY.TREATMENTS) {
              const otherAnswerValue = a.value?.split(":")

              prev[`${answerKey}Other/${a.key}`] = otherAnswerValue[0]?.trim();
              if (otherAnswerValue[1]) {
                prev[`${answerKey}Other/${a.key}Other`] = otherAnswerValue[1]?.trim();

                if (otherAnswerValue?.[1]?.split("-")?.length > 1) {
                  const otherInputValue = otherAnswerValue?.[1]?.split("-");
                  if (otherInputValue[0]?.trim() === "Uncertain") {
                    prev[`${answerKey}Other/${a.key}Other`] = "@UN";
                    prev[`${answerKey}Other/${a.key}OtherUncertain`] = otherInputValue[1]?.trim();

                  }
                  if (otherInputValue[0]?.trim() === "Other") {
                    prev[`${answerKey}Other/${a.key}Other`] = "OT";
                    prev[`${answerKey}Other/${a.key}OtherOther`] = otherInputValue[1]?.trim();

                  }
                }
              }

            }
          }

          if (!!a.followUpValue) {
            const followUpKeys = Object.keys(a.followUpValue);
            followUpKeys.forEach((followUpKey: string) => {
              prev[`${answerKey}followUpQ/${a.key}/${followUpKey}`] = a.followUpValue[followUpKey]
            })
          }

        } else if (question?.type === 'date' && (a.key || a.value)) {
          if (question.key === QUESTIONS_KEY.RECIPIENT_DOB && a?.isAge) {
            if (a?.isAge == 0 || a?.isAge == 2) {
              prev[`${answerKey}`] = moment(a.key || a.value).format(getFormatDate(market))
            }
            if (a?.isAge == 1 || a?.isAge == 2) {
              const bornYear = parseInt(moment(a.key || a.value).format("YYYY"));
              const nowYear = new Date().getFullYear()
              prev[`${answerKey}Age`] = nowYear - bornYear
            }

          } else {
            prev[`${answerKey}`] = moment(a.key || a.value).format(getFormatDate(market))
          };
        } else if (question?.type === 'datetime' && a.value) {
          prev[`${answerKey}`] = a.value;
          prev[`${answerKey}date`] = moment(a?.value?.split(' ')?.[0], getFormatDate(market))?.format(getFormatDate(market));
          prev[`${answerKey}time`] = `${a?.value?.split(' ')?.[1]} ${a?.value?.split(' ')?.[2]}`;
          if (QUESTIONS_KEY.SERVICES_START_DATE == question.key) {
            const serviceDateTime = moment(a.value).format("MM-DD-YYYY hh:mm A");
            prev[`${answerKey}`] = serviceDateTime;
            prev[`${answerKey}date`] = moment(serviceDateTime?.split(' ')?.[0], getFormatDate(market))?.format(getFormatDate(market));
            prev[`${answerKey}time`] = `${serviceDateTime?.split(' ')?.[1]} ${serviceDateTime?.split(' ')?.[2]}`;
          }

        } else if (question?.type === 'text' && address) {
          prev[`${answerKey}`] = address;
        } else {
          // string
          prev[`${answerKey}`] = a.key || a.value;
        }
      });

      if (question.key === QUESTIONS_KEY.PET_CARE && answer[0].value) {
        if (['2', '3'].includes(answer[0].key)) {
          prev[`${answerKey}Other`] = answer[0].value
        } else {
          const values = answer[0].value.split(",");
          values.map((value: string) => {
            const item = value.trim().split(":");
            prev[`${answerKey}Other/${item[0]}`] = item[1];
          })
        }
      }
      if ([QUESTIONS_KEY.BATHING, QUESTIONS_KEY.NUTRITION].includes(question.key)) {
        if (answer[0].key && !!answer[0].value) {
          const otherAnswer = answer[0].value.split(",").map((a: string) => {
            if (a.includes("Other:")) {
              prev[`${answerKey}OtherKeyOther`] = a.split(":").splice(1).join(':').trim();
              return "OT";
            }
            return a.trim();
          });
          prev[`${answerKey}OtherKey`] = otherAnswer
        }
      }

      if (question.key === QUESTIONS_KEY.TRANSFERS) {
        if (answer[0].key && !!answer[0].value) {
          answer[0].value.split(",").map((a: string) => {
            const otherTransfersValue = a.split(":");
            if (otherTransfersValue.length > 1) {
              prev[`${answerKey}Other/${otherTransfersValue[0].trim()}`] = otherTransfersValue[1].trim().split("(")[0].trim();
              return;
            }
            prev[`${answerKey}Other/select`] = otherTransfersValue[0].trim();
          })

        }
      }
      if (isCommonApp) {
        if (question.key === QUESTIONS_KEY.CONTACT_TIME_DATE) {
          const value = answer[0].value.split(",");

          prev[`${answerKey}name`] = value[0].split(':')[1].trim();
          prev[`${answerKey}phone`] = value[1].split(':')[1].trim();
          prev[`${answerKey}email`] = value[2].split(':')[1].trim();

          const dateTimeValue = value[3].substring(value[3].indexOf(":") + 1).trim()
          prev[`${answerKey}date`] = moment(dateTimeValue.split(' ')[0], getFormatDate(market)).format(getFormatDate(market));
          prev[`${answerKey}time`] = `${dateTimeValue.split(' ')[1]} ${dateTimeValue.split(' ')[2]}`;
          prev[`${answerKey}timeZone`] = dateTimeValue.split(' ')[3]
        }

        if (question.key === QUESTIONS_KEY.READY_TO_SCHEDULE_HOME_APPT) {
          if (answer[0].key && !!answer[0].value) {
            prev[`${answerKey}Other`] = answer[0].value;
          }
        }
        if (question.key === QUESTIONS_KEY.RELATIONSHIP) {
          if (answer[0].key && !!answer[0].value) {
            const answerArray = answer[0].value.split(":");
            if (answerArray.length > 0 && answerArray[0].trim() === "Other") {
              prev[`${answerKey}OtherKey`] = "OT";
              prev[`${answerKey}OtherKeyOther`] = answerArray.splice(1).join(':');
            } else prev[`${answerKey}OtherKey`] = answer[0].value;
          }
        }

      }

      if (question.key == QUESTIONS_KEY.COMPANION_SITTERALL) {

        const servicesAnswer = answer[0]?.key;
        let disable = false;
        if (servicesAnswer == "1") {
          disable = true;

        }
        if (servicesAnswer == "strm") {
          const otherInputAnswer = answer[0]?.value;
          if (otherInputAnswer?.includes("Companion/Sitter")) {
            disable = true;
          }
        }
        if (generation === GENERATION_V3) {
          disable = false;
          const companionAnswer = answer[0]?.followUpValue?.companion_hands_on_help;
          if (companionAnswer === 'no_companionship') {
            disable = true;
          }
        }

        IadlServices.current[answerKey?.split("/")[0]] = disable
      }

      if(generation === GENERATION_V3 && QUESTION_KEY_HAS_OTHER_INPUT.includes(question.key) && answer[0].value){
        prev[`${answerKey}CheckboxOther`] = "OT";
      }
      return prev;
    }, {});
    return result;
  };
  const getQuestionKey = (questionKey: string) => {
    const question = getQuestionByKey(questionKey);
    if (!!question?.key) return question;
    return questions.find((q: API.Question) => questionKey.includes(q.key));
  };
  const convertOldQuoteVersionAnswers = (answersHistory: any, currentCategories: API.Category[] = categories) => {
    const newAnswers: Record<string, unknown> = {};
    Object.entries(answersHistory)?.forEach(([key, value]) => {
      const { qKey, qRecipient, optionKey } = convertAnswerKey(key);
      if (qKey) {
        const question = getQuestionKey(qKey);
        if (!question?.categories?.length) return;
        const category = currentCategories.find((ca: API.Category) => {
          const matchesCategory = question?.categories?.some((c: string) => c === ca.id) ?? false;
          if (!matchesCategory) return false;
          if (qRecipient === DEFAULT_CATEGORY_RECIPIENTS) {
            return !ca.name?.includes('(2)');
          }
          return ca.name?.includes('(2)');
        });
        if (!category) return;
        const newAnswerKey = `${qRecipient}/${category?.key || ''}/${qKey}${optionKey ? `/${optionKey}` : ''}`;
        newAnswers[newAnswerKey] = value;
      }
    });
    setAnswers(newAnswers);
  };

  const { loading: loadingQuoteHistory, run: fetchQuoteHistory } = useRequest(
    (QC: string, token?: string) => getQuoteHistory({ quoteCode: QC, client: client?.appType ?? '', token: token  }),
    {
      cacheKey: 'getQuoteHistory',
      manual: true,
      formatResult: (res) => res,
      onSuccess: (data) => {
        setQuote(data);
        setQuoteCode(data?.quoteCode);
        setIsPrimaryQuote(data?.isPrimaryQuote);
        setIsSibling(data?.isSibling);
        const answerConverted = convertQuoteHistory(data?.quoteItems);
        setAnswers(answerConverted);
        setCareRecipientName(answerConverted);

        if (!!getAnswerAdditionalPerson(answerConverted)) {
          fetchCategories({
            recipients: getAnswerAdditionalPerson(answerConverted),
            nextCate: false,
            isPrimaryQuote: data?.isPrimaryQuote,
            isSibling: data?.isSibling,
            callBack: (newFetchedCategories: any[]) => {
              if (!isCommonApp && !data?.requestInfo?.cni_multiplier) {
                convertOldQuoteVersionAnswers(answerConverted, newFetchedCategories);
              }
            }
          });
        } else {
          if (!isCommonApp && !data?.requestInfo?.cni_multiplier) {
            convertOldQuoteVersionAnswers(answerConverted)
          }
        }

      },
    },
  );

  const setOldQuoteData = (data: any, QC: string, callBack?: any) => {
    const langKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.SELECT_LANGUAGE);
    const staffKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.IS_STAFF);
    const staffNameKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.STAFF_MEMBER_NAME);
   const reassessmentKey = langKey ? langKey.replace(QUESTIONS_KEY.SELECT_LANGUAGE, QUESTIONS_KEY.CREATE_A_NEW_QUOTE) : '';
    const reassessmentOldKey = reassessmentKey ? `${reassessmentKey}OldQuote` : '';

    const currentQuestion: any = {};
    if (langKey) currentQuestion[langKey] = answers[langKey];
    if (staffKey && generation !== GENERATION_V3) {
      currentQuestion[staffKey] = answers[staffKey] === '1' ? '1' : '';
    }

    if (staffKey && generation === GENERATION_V3) {
      currentQuestion[staffKey] = answers[staffKey];
      const referralSourceNameKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.REFERRAL_SOURCE_NAME);
      if (referralSourceNameKey) currentQuestion[referralSourceNameKey] = answers[referralSourceNameKey];
    }
    if (staffNameKey) currentQuestion[staffNameKey] = answers[staffNameKey];
    if (reassessmentKey) currentQuestion[reassessmentKey] = '1';
    if (reassessmentOldKey) currentQuestion[reassessmentOldKey] = QC;
  

    setQuote(data);
    setIsPrimaryQuote(data?.isPrimaryQuote);
    setIsSibling(data?.isSibling);

    const answerConverted = convertQuoteHistory(data?.quoteItems);
    const oldStaffKey = getDynamicAnswerKey(Object.keys(answerConverted), QUESTIONS_KEY.IS_STAFF);
    const oldStaffNameKey = getDynamicAnswerKey(Object.keys(answerConverted), QUESTIONS_KEY.STAFF_MEMBER_NAME);
    if (oldStaffKey) delete answerConverted[oldStaffKey];
    if (oldStaffNameKey) delete answerConverted[oldStaffNameKey];

    // TRM 7.3: keep the full prior answers for display; fresh-only questions are not carried forward
    priorAnswers.current = { ...answerConverted };
    setObjectState((prev: any) => ({ ...prev, reassessConfirm: {} }));
    const newAnswer = { ...removeFreshAnswers(answerConverted), ...currentQuestion };
    setCareRecipientName(newAnswer);
    setAnswers(newAnswer);
    if (!!getAnswerAdditionalPerson(answerConverted)) {
      fetchCategories({
        recipients: getAnswerAdditionalPerson(answerConverted),
        nextCate: false,
        isPrimaryQuote: data?.isPrimaryQuote,
        isSibling: data?.isSibling,
        callBack: (newFetchedCategories: any[]) => {
          if (!isCommonApp && !data?.requestInfo?.cni_multiplier) {
            convertOldQuoteVersionAnswers(newAnswer, newFetchedCategories);
          }

          if (callBack) {
            callBack();
          }
        },
      });
    } else {
      const newCategories = categories.filter(
        (r: API.Category) => !r?.name?.includes('(2)') || r?.key === CATEGORY_KEYS?.[generation]?.['review'],
      );
      if (newCategories.length > 0) {
        setCategories(newCategories || []);
      }
      if (!isCommonApp && !data?.requestInfo?.cni_multiplier) {
        convertOldQuoteVersionAnswers(newAnswer, newCategories)
      }
      if (callBack) {
        callBack();
      }
    }


  }
  const { run: fetchOldQuoteHistory } = useRequest(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ({ QC, callBack }: { QC: string; callBack?: any }) =>
      getQuoteHistory({ quoteCode: QC, client: client?.appType ?? '' }),
    {
      cacheKey: 'getQuoteHistory',
      manual: true,
      formatResult: (res) => res,
      onSuccess: (data, [{ callBack, QC }]) => {
        const isSecondary = !data?.isPrimaryQuote && !!data?.siblingQuoteCode;
        quoteDataRef.current = {
          ...data
        }
        if (!isSecondary) {
          const langKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.SELECT_LANGUAGE);
          const staffKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.IS_STAFF);
          const staffNameKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.STAFF_MEMBER_NAME);
          const reassessmentKey = langKey ? langKey.replace(QUESTIONS_KEY.SELECT_LANGUAGE, QUESTIONS_KEY.CREATE_A_NEW_QUOTE) : '';
          const reassessmentOldKey = reassessmentKey ? `${reassessmentKey}OldQuote` : '';
         
          const currentQuestion: any = {};
          if (langKey) currentQuestion[langKey] = answers[langKey];
          if (staffKey && generation !== GENERATION_V3) {
            currentQuestion[staffKey] = answers[staffKey] === '1' ? '1' : '';
          }

          if (staffKey && generation === GENERATION_V3) {
            currentQuestion[staffKey] = answers[staffKey];
            const referralSourceNameKey = getDynamicAnswerKey(Object.keys(answers), QUESTIONS_KEY.REFERRAL_SOURCE_NAME);
            if (referralSourceNameKey) currentQuestion[referralSourceNameKey] = answers[referralSourceNameKey];
          }

          if (staffNameKey) currentQuestion[staffNameKey] = answers[staffNameKey];
          if (reassessmentKey) currentQuestion[reassessmentKey] = '1';
          if (reassessmentOldKey) currentQuestion[reassessmentOldKey] = QC;
         

          setQuote(data);
          setIsPrimaryQuote(data?.isPrimaryQuote);
          setIsSibling(data?.isSibling);

          const answerConverted = convertQuoteHistory(data?.quoteItems);
          const oldStaffKey = getDynamicAnswerKey(Object.keys(answerConverted), QUESTIONS_KEY.IS_STAFF);
          const oldStaffNameKey = getDynamicAnswerKey(Object.keys(answerConverted), QUESTIONS_KEY.STAFF_MEMBER_NAME);
          if (oldStaffKey) delete answerConverted[oldStaffKey];
          if (oldStaffNameKey) delete answerConverted[oldStaffNameKey];

          // TRM 7.3: keep the full prior answers for display; fresh-only questions are not carried forward
          priorAnswers.current = { ...answerConverted };
          setObjectState((prev: any) => ({ ...prev, reassessConfirm: {} }));
          const newAnswer = { ...removeFreshAnswers(answerConverted), ...currentQuestion };
           setCareRecipientName(newAnswer);
          setAnswers(newAnswer);
          if (!!getAnswerAdditionalPerson(answerConverted)) {
            fetchCategories({
              recipients: getAnswerAdditionalPerson(answerConverted),
              nextCate: false,
              isPrimaryQuote: data?.isPrimaryQuote,
              isSibling: data?.isSibling,
              callBack: (newFetchedCategories: any[]) => {

                if (!isCommonApp && !data?.requestInfo?.cni_multiplier) {
                  convertOldQuoteVersionAnswers(newAnswer, newFetchedCategories);
                }
                if (callBack) {
                  callBack();
                }

              },
            });
          } else {
            if (!isCommonApp && !data?.requestInfo?.cni_multiplier) {
              convertOldQuoteVersionAnswers(newAnswer);
            }
            if (callBack) {
              callBack();
            }

          }
        }
      },
    },
  );

  const { run: runAskForCall } = useRequest((params: any) => createQuote({ ...params, isDemo }), {
    cacheKey: 'askForCall',
    manual: true,
    formatResult: (res) => res,
    onSuccess: (data) => {
      setQuote(data);
    },
  });

  const askForCall = (values: any) => {
    runAskForCall({
      answers: convertAnswers(),
      client: client?.appType,
      quoteCode: quoteCode,
      isDraft: 1,
      answersKey: convertAnswers(true),
      ...values,
    });
  };

  const { run: getListOldQuote, loading: loadingRelatedQuotes } = useRequest(
    (params: any) => getListOldQuotes({ ...params }),
    {
      cacheKey: 'getListOldQuotes',
      manual: true,
      formatResult: (res) => res,
      onSuccess: (data) => {
        setQuote(data);
      },
    },
  );

  useEffect(() => {
    setSavedDraft(false);
    if (!sendMail.current) {
      setCreatedQuote(false);
    }
    sendMail.current = false;
  }, [answers]);

  return {
    quote,
    setQuote,
    submitCreateQuote,
    createdQuote,
    setCreatedQuote,
    creatingQuote: loading,
    convertAnswerKey,

    quoteCode,
    setQuoteCode,
    runGenerateQuoteCode,
    fetchQuoteHistory,
    isPrimaryQuote,
    isSibling,

    savedDraft,
    saveDraft,

    askForCall,
    addedForCall,
    setAddedForCall,

    loadingGenerateQuoteCode,
    loadingQuoteHistory,

    loadingRelatedQuotes,
    getListOldQuote,
    fetchOldQuoteHistory,
    sendMail,
    saveDraftCommonApp,
    isHiddenPrice,
    quoteDataRef,
    setOldQuoteData,
  };
}
